import { TStatisticsField, TStatisticsGroup, TStatsPeriod } from '../../store/types';

export const statsPeriodList: TStatsPeriod[] = [
  'today',
  'yesterday',
  'week',
  'month',
  'all',
];

export const statsPeriodTitles: Record<TStatsPeriod, string> = {
  today: 'Сегодня',
  yesterday: 'Вчера',
  week: 'Эта неделя',
  month: 'Этот месяц',
  all: 'Всё время',
};

export const statisticsTitles: Record<TStatisticsField, string> = {
  totalRequests: 'Общее кол-во заявок',
  totalApproved: 'Кол-во подтверждённых заявок',
  transactionsCount: 'Кол-во транзакций',
  transactionsAmount: 'Общая сумма транзакций',
  remoteTransactionsCount: 'Кол-во по сторонним методам',
  remoteTransactionsAmount: 'Сумма по сторонним методам',
  customTransactionsCount: 'Кол-во по своим методам',
  customTransactionsAmount: 'Сумма по своим методам',
  activeWithdrawalsAmount: 'Сумма активных заявок на вывод',
  approvedWithdrawalsAmount: 'Сумма выплаченных заявок',
  totalBalance: 'Общий баланс магазинов',
};

export const statisticsGroups: TStatisticsGroup[] = [
  {
    title: 'Платежи',
    fields: ['totalRequests', 'totalApproved'],
  },
  {
    title: 'Транзакции',
    fields: [
      'transactionsCount',
      'transactionsAmount',
      'remoteTransactionsCount',
      'remoteTransactionsAmount',
      'customTransactionsCount',
      'customTransactionsAmount',
    ],
  },
  {
    title: 'Выводы',
    fields: ['activeWithdrawalsAmount', 'approvedWithdrawalsAmount'],
  },
  {
    title: 'Баланс',
    fields: ['totalBalance'],
  },
];
